import { useState } from 'react';

import { Box, CircularProgress, Typography, Table, TableHead, TableCell, TableBody, TableRow } from '@mui/material';

import { OutlineButton } from 'components/buttons/OutlineButton';

const WeakClientTable = ({ isLoading, weakClientList }) => {
  const [visibleCount, setVisibleCount] = useState(5);

  return (
    <Box sx={{ width: '100%' }}>
      {isLoading ? (
        <Box
          sx={{
            height: 220,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress size={24} />
        </Box>
      ) : weakClientList?.length === 0 ? (
        <Typography sx={{ color: '#8E8E93', textAlign: 'center', py: 4 }}>No data available</Typography>
      ) : (
        <Table
          sx={{
            '& .MuiTableCell-root': {
              py: 1,
            },
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                '& .MuiTableCell-root': {
                  borderBottom: '1px solid #e0e0e0',
                  paddingTop: 0,
                  paddingBottom: '12px',
                },
              }}
            >
              <TableCell>
                <Typography fontWeight={500} fontSize={15}>
                  Device Name
                </Typography>
              </TableCell>
              <TableCell>
                <Typography fontWeight={500} fontSize={15}>
                  Clients
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              '& .MuiTableCell-root': {
                borderBottom: 'none',
              },
            }}
          >
            {weakClientList.slice(0, visibleCount).map(row => (
              <TableRow key={row.deviceId}>
                <TableCell
                  sx={{
                    wordBreak: 'break-word',
                    color: '#1C1C1E',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {row.deviceName}
                </TableCell>
                <TableCell
                  sx={{
                    color: '#1C1C1E',
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                >
                  {row.count}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {weakClientList?.length > visibleCount && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <OutlineButton
            variant="text"
            onClick={() => setVisibleCount(v => Math.min(v + 5, weakClientList.length))}
            sx={{
              height: 32,
              textTransform: 'none',
              color: '#172664',
              border: '1px solid #172664',
              backgroundColor: 'transparent',
            }}
          >
            Show more
          </OutlineButton>
        </Box>
      )}
    </Box>
  );
};

export default WeakClientTable;
